import { DynamcColumnComponent } from '../../component-table/dynamic-column.component';
import { EventEmitter } from '@angular/core';

export class VitalRequestsConfigService {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor () {
    // const self = this;
    this.settings = {
      selectMode: 'multi',
      mode: 'external',
      noDataMessage: 'No hay registros para mostrar.',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
      }
    };
  }

  /**
   * Genera las columnas dinamicas del calendario de actividades
   *
   * @param {string} key
   * @param {string} title
   * @memberof VitalRequestsConfigService
   */
  generateColumn(key: string, title: string) {
    this.settings['columns'][key] = {
      title: title,
      editable: false,
      type: 'custom',
      renderComponent: DynamcColumnComponent,
      onComponentInitFunction() {}
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/view-vital-requests/shared/view-vital-requests.config.service.ts